import { render } from "./ReaderRegister.vue?vue&type=template&id=76d0441b&scoped=true"
import script from "./ReaderRegister.vue?vue&type=script&lang=js"
export * from "./ReaderRegister.vue?vue&type=script&lang=js"

import "./ReaderRegister.vue?vue&type=style&index=0&id=76d0441b&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d0441b"]])

export default __exports__